module.exports = __webpack_public_path__ + "static/img/mens_acteurs_1.db12770.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blocks/mens_acteurs_1.svg
// module id = df3G
// module chunks = 0